document.addEventListener("DOMContentLoaded", function () {
  const announcementWrapper = document.querySelector(".amd-header-announcement__container--wrapper");
  const announcementContainer = document.querySelector(".amd-header-announcement__container");
  const announcementCopies = document.querySelectorAll(".amd-header-announcement__copy");

  if (announcementContainer && announcementWrapper) {
    if (announcementCopies.length === 1) {
      announcementContainer.classList.add("no-marquee");
      announcementContainer.style.animation = "none";
    } else {
      let clonesToAdd = 0;
      if (announcementCopies.length === 2) {
        clonesToAdd = 4;
      } else if (announcementCopies.length === 3) {
        clonesToAdd = 2;
      }

      for (let i = 0; i < clonesToAdd; i++) {
        const clone = announcementContainer.cloneNode(true);
        announcementWrapper.appendChild(clone);
      }
    }
  }
});


document.addEventListener('scroll', () => {
  const header = document.querySelector('.site-header');
  if (window.scrollY > 0) {
      header.classList.add('sticky-header');
  } else {
      header.classList.remove('sticky-header');
  }
});


document.querySelector('.site-header__hamburger').addEventListener('click', function () {
  this.classList.toggle('mobile_menu_active');
  document.querySelector('.amd-header-mobile').classList.toggle('mobile_menu_active');
  document.querySelector('body').classList.toggle('overflow-hidden');
});



document.querySelectorAll('.amd-header-mobile-collapse--button').forEach(collapseBtn => {
  collapseBtn.addEventListener('click', function () {
    const listItem = this.closest('.amd-header-mobile__list-item--has-dd'); 
    if (listItem) {
      const dropdown = listItem.querySelector('.amd-header-mobile__dropdown'); 
      this.classList.toggle('collapse_dropdown'); 
      if (dropdown) {
        dropdown.classList.toggle('collapse_dropdown'); 
      }
    }
  });
});



const menuItemsMain = document.querySelectorAll('.amd-header_top_level_link');
const submenusMain = document.querySelectorAll('.amd-header-submenu'); 
const redLineMain = document.querySelector('.amd-menu-red-line-main');
let timeoutMain;

menuItemsMain.forEach((item) => {
  item.addEventListener('mouseenter', (e) => {
    clearTimeout(timeoutMain);
    setRedLinePositionMain(e.target);
  });

  item.addEventListener('mouseleave', () => {
    startRedLineTimeoutMain();
  });
});

submenusMain.forEach((submenu) => {
  submenu.addEventListener('mouseenter', () => clearTimeout(timeoutMain));
  submenu.addEventListener('mouseleave', () => startRedLineTimeoutMain());
});

const menuItemsSecond = document.querySelectorAll('.secondary_link');
const submenusSecond = document.querySelectorAll('.amd-header_top_secondary--submenu'); // Submenus
const redLineSecond = document.querySelector('.amd-menu-red-line-scnd');
let timeoutSecond;

menuItemsSecond.forEach((item) => {
  item.addEventListener('mouseenter', (e) => {
    clearTimeout(timeoutSecond);
    setRedLinePositionSecond(e.target);
  });

  item.addEventListener('mouseleave', () => {
    startRedLineTimeoutSecond();
  });
});

submenusSecond.forEach((submenu) => {
  submenu.addEventListener('mouseenter', () => clearTimeout(timeoutSecond));
  submenu.addEventListener('mouseleave', () => startRedLineTimeoutSecond());
});

function setRedLinePositionMain(target) {
  const { left, width } = target.getBoundingClientRect();
  const menuOffsetLeft = document.querySelector('.amd-header_bottom').getBoundingClientRect().left;

  redLineMain.style.width = `${width - 24}px`;
  redLineMain.style.left = `${left - menuOffsetLeft + 12}px`;
  redLineMain.style.height = '4px';
}

function startRedLineTimeoutMain() {
  timeoutMain = setTimeout(() => {
    redLineMain.style.height = '0px';
  }, 300);
}

function setRedLinePositionSecond(target) {
  const { left, width } = target.getBoundingClientRect();
  const menuOffsetLeft = document
    .querySelector('.amd-header_top_secondary--menu')
    .getBoundingClientRect().left;

  redLineSecond.style.width = `${width - 16}px`;
  redLineSecond.style.left = `${left - menuOffsetLeft + 8}px`;
  redLineSecond.style.height = '4px';
}

function startRedLineTimeoutSecond() {
  timeoutSecond = setTimeout(() => {
    redLineSecond.style.height = '0px';
  }, 300);
}
